import { Model } from '@vuex-orm/core';

export default class Glossar extends Model {
  static entity = 'glossar';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {number | null} */
    this.id;
    /** @type {string | null} */
    this.titel_de;
    /** @type {string | null} */
    this.beschreibung_de;
    /** @type {string | null} */
    this.link;
    /** @type {string | null} */
    this.keywords_de;
    /** @type {any} */
    this.generiert;
    /** @type {any} */
    this.sieheauch;
    /** @type {string | null} */
    this.titel_en;
    /** @type {string | null} */
    this.beschreibung_en;
    /** @type {string | null} */
    this.keywords_en;
  }

  static fields() {
    return {
      id: this.number(0).nullable(),
      titel_de: this.string('').nullable(),
      beschreibung_de: this.string('').nullable(),
      link: this.string('').nullable(),
      keywords_de: this.string('').nullable(),
      generiert: this.attr(undefined).nullable(),
      sieheauch: this.attr([]).nullable(),
      titel_en: this.string('').nullable(),
      beschreibung_en: this.string('').nullable(),
      keywords_en: this.string('').nullable()
    };
  }
}
